module.exports = __webpack_public_path__ + "static/media/winner.96589816.jpg";